/// <amd-module name="Feed/Legacy/Protocols/Common/ISupportedFeatures" />
export interface ISupportedFeatures {
    /**
     * Is upstreams enabled for the protocol
     */
    upstreams: boolean;
    /**
     * Is project scoped feeds enabled for the protocol
     */
    projectScopedFeeds: boolean;
    /**
     * Are public upstreams supported for the protocol
     */
    publicUpstreams?: boolean;
}
